import React from 'react';
import { CheckCircle2 } from 'lucide-react';
const credentials = ['Certificate IV in Finance Broking', '20 Year Member of the Mortgage and Finance Association of Australia', 'Finance Broking since 2001', 'Former Westpac Business Banking Manager', 'Assist with equipment financing and personal loans', "Part of the country's largest broking company (organises 1 in 10 home loans nationwide)", 'Compare 1,350+ financial products across 31+ lenders including the Big 4 Banks', 'Local resident fully committed to Secret Harbour and surrounding areas', 'Member of the Credit Industry Ombudsman (#407734)', 'Professional Indemnity Insurance up to $20,000,000 (ASIC #503825)'];
export function CredentialsSection() {
  return <section className="py-16 sm:py-20 bg-background-gray-light" data-id="element-54">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-55">
        <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-56">
          <h2 className="text-3xl font-heading text-text-title mb-4" data-id="element-57">
            How Jerry Gibb can help you with your next home loan
          </h2>
          <p className="text-text-default text-lg" data-id="element-58">
            Experience the convenience of state-of-the-art technology combined
            with decades of local expertise.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-5xl mx-auto" data-id="element-59">
          {credentials.map((item, idx) => <div key={idx} className="flex items-start gap-3 bg-neutral-white p-5 rounded-lg shadow-sm border border-border-default" data-id="element-60">
              <CheckCircle2 className="w-6 h-6 text-text-success-default flex-shrink-0 mt-0.5" data-id="element-61" />
              <span className="text-text-default leading-relaxed" data-id="element-62">{item}</span>
            </div>)}
        </div>
      </div>
    </section>;
}